module.exports = __webpack_public_path__ + "media/images/emblems/Courgevaux-coat_of_arms-085530576274b2ffe9e29d82e421666b.svg";